// extracted by mini-css-extract-plugin
module.exports = {"linkDetails":"AllReports_linkDetails_2EPmo"};